module.exports = __webpack_public_path__ + "static/media/Sending.08beff5a.png";